import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { useMemo } from 'react';

const CHART_DEFAULTS = {
  background: { visible: false },
  title: { enabled: false },
  subtitle: { enabled: false },
  tooltip: { enabled: true },
  legend: { enabled: true },
  animation: { enabled: true },
  zoom: { enabled: false }
}

export const useChartOptions = ({widgetId}) => {
  const chartOptionsSettings = useSelector(s => s.dashboard.widgets[widgetId].settings.chartOptions || {});
  const chartOptions = useMemo(() => merge({}, CHART_DEFAULTS, chartOptionsSettings), [chartOptionsSettings]);

  return {
    chartOptions
  }
}
